import { ReactComponent as EyeInvisible } from 'images/icons/EyeInvisibleFilled.svg';
import './TagHidden.scss';

export const TagHidden = () => {
  return (
    <div className='hidden-tag'>
      <EyeInvisible className='icon' />
      <div className='hidden-tag-text'>Hidden For User </div>
    </div>
  );
}